<template>
    <section id="tour_booking_submission" class="section_padding">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div v-if="departure_flight" class="clearfix mb20" id="flight-selected">
                        <div class="itinerary-content mb20">
                            <div class="row no-margin align-items-center" id="itinerary-content-outbound-header">
                                <div class="col-md-6 col-8">
                                    <img src="@/assets/img/svg/img_icon_flighttake_off.svg">
                                    <div class="inline-middle pl-3 pr-3">
                                        <h4 class="new-bold-light bold mb0">{{ $t('Departure Flight') }}</h4>
                                        <span class="dep-date font-14">
                                            {{
                                                getFormattedDate(departure_flight.itineraries[0].segments[0].departure.at)
                                            }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-6 col-4"></div>
                            </div>
                            <div class="row  align-items-center mb-3">
                                <div class="col-md-5">
                                    <div class="p10" id="itinerary-content-outbound-map">
                                        <div id="outbound-map" class="flight-map">
                                            <img :src="this.getOutboundImg">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-7">
                                    <div class="departure-itinerary">
                                        <div class="itinerary">
                                            <div v-for="(segment, index) in departure_flight.itineraries[0].segments">
                                                <div class="row no-margin p20 fl-itinerary">
                                                    <div class="col-md-4 mt20 text-center">
                                                        <div>
                                                            <h3 class="prime-color">
                                                                {{ segment.departure.iataCode }}
                                                            </h3>
                                                            <h4 class="no-margin new-light">
                                                                {{ getFormattedTime(segment.departure.at) }}
                                                            </h4>
                                                            <span>
                                                                {{ getFormattedDate(segment.departure.at) }}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <div class="ellipsis no-wrap">
                                                                {{
                                                                    getLocationByCode(segment.departure.iataCode)[$i18n.locale
                                                                    + '_name']
                                                                }}
                                                            </div>
                                                            <div class="ellipsis no-wrap">
                                                                {{
                                                                    getLocationByCode(segment.departure.iataCode)[$i18n.locale
                                                                    + '_city']
                                                                }},
                                                                {{
                                                                    getLocationByCode(segment.departure.iataCode)[$i18n.locale
                                                                    + '_country']
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 text-center">
                                                        <div class="mb5">
                                                            <div class="fl-img-con">
                                                                <div
                                                                    :class="'flight-image i-' + segment.carrierCode.toLowerCase()">
                                                                </div>
                                                            </div>
                                                            <p class="no-margin font-12">
                                                                <span>
                                                                    {{ this.airlines[segment.carrierCode][$i18n.locale]
                                                                    }}
                                                                </span>
                                                            <p class="clearfix">
                                                                {{ segment.carrierCode }}{{ segment.number }}
                                                            </p>
                                                            </p>
                                                            <span>{{ $t(this.searchData.cabin) }}</span>
                                                        </div>
                                                        <div>
                                                            <div>{{ convertDuration(segment.duration) }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 mt20 text-center">
                                                        <div>
                                                            <h3 class="prime-color">{{ segment.arrival.iataCode }}</h3>
                                                            <h4 class="no-margin new-light">
                                                                {{ getFormattedTime(segment.arrival.at) }}
                                                            </h4>
                                                            <span>
                                                                {{ getFormattedDate(segment.arrival.at) }}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <div class="ellipsis no-wrap">
                                                                {{
                                                                    getLocationByCode(segment.arrival.iataCode)[$i18n.locale
                                                                    + '_name']
                                                                }}
                                                            </div>
                                                            <div class="ellipsis no-wrap">
                                                                {{
                                                                    getLocationByCode(segment.arrival.iataCode)[$i18n.locale
                                                                    + '_city']
                                                                }},
                                                                {{
                                                                    getLocationByCode(segment.arrival.iataCode)[$i18n.locale
                                                                    + '_country']
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="index < departure_flight.itineraries[0].segments.length - 1"
                                                    class="col-md-12">
                                                    <div class="clearfix layover">
                                                        <span>
                                                            {{ $t('Stop') }}
                                                            {{ getStopDuration($i18n.locale, segment.arrival.at,
                                                                departure_flight.itineraries[0].segments[index +
                                                                    1].departure.at)
                                                            }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="this.tripType != 'oneway'" class="col-md-12">
                    <div v-if="departure_flight" class="clearfix mb20" id="flight-selected">
                        <div class="itinerary-content ib-con mb20">
                            <div class="row no-margin align-items-center">
                                <div class="col-md-6 col-8">
                                    <img src="@/assets/img/svg/img_icon_flightlanding.svg">
                                    <div class="inline-middle pl-3 pr-3">
                                        <h4 class="new-bold-light bold mb0">{{ $t('Return Flight') }}</h4>
                                        <span class="arr-date font-14">
                                            {{
                                                getFormattedDate(arrival_flight.itineraries[1].segments[0].departure.at)
                                            }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-6 col-4"></div>
                            </div>
                            <div class="row align-items-center mb-3">
                                <div class="col-md-5">
                                    <div class="p10">
                                        <div id="inbound-map" class="map">
                                            <img :src="this.getInboundImg">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-7">
                                    <div class="arrival-itinerary ib-con">
                                        <div class="itinerary">
                                            <div v-for="(segment, index) in arrival_flight.itineraries[1].segments">
                                                <div class="row no-margin p20 fl-itinerary">
                                                    <div class="col-md-4 mt20 text-center">
                                                        <div>
                                                            <h3 class="prime-color">
                                                                {{ segment.departure.iataCode }}
                                                            </h3>
                                                            <h4 class="no-margin new-light">
                                                                {{ getFormattedTime(segment.departure.at) }}
                                                            </h4>
                                                            <span>
                                                                {{ getFormattedDate(segment.departure.at) }}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <div class="ellipsis no-wrap">
                                                                {{
                                                                    getLocationByCode(segment.departure.iataCode)[$i18n.locale
                                                                    + '_name']
                                                                }}
                                                            </div>
                                                            <div class="ellipsis no-wrap">
                                                                {{
                                                                    getLocationByCode(segment.departure.iataCode)[$i18n.locale
                                                                    + '_city']
                                                                }},
                                                                {{
                                                                    getLocationByCode(segment.departure.iataCode)[$i18n.locale
                                                                    + '_country']
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 text-center">
                                                        <div class="mb5">
                                                            <div class="fl-img-con">
                                                                <div
                                                                    :class="'flight-image i-' + segment.carrierCode.toLowerCase()">
                                                                </div>
                                                            </div>
                                                            <p class="no-margin font-12">
                                                                <span>
                                                                    {{ this.airlines[segment.carrierCode][$i18n.locale]
                                                                    }}
                                                                </span>
                                                            <p class="clearfix">
                                                                {{ segment.carrierCode }}{{ segment.number }}
                                                            </p>
                                                            </p>
                                                            <span>{{ $t(this.searchData.cabin) }}</span>
                                                        </div>
                                                        <div>
                                                            <div>{{ convertDuration(segment.duration) }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 mt20 text-center">
                                                        <div>
                                                            <h3 class="prime-color">{{ segment.arrival.iataCode }}</h3>
                                                            <h4 class="no-margin new-light">
                                                                {{ getFormattedTime(segment.arrival.at) }}
                                                            </h4>
                                                            <span>
                                                                {{ getFormattedDate(segment.arrival.at) }}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <div class="ellipsis no-wrap">
                                                                {{
                                                                    getLocationByCode(segment.arrival.iataCode)[$i18n.locale
                                                                    + '_name']
                                                                }}
                                                            </div>
                                                            <div class="ellipsis no-wrap">
                                                                {{
                                                                    getLocationByCode(segment.arrival.iataCode)[$i18n.locale
                                                                    + '_city']
                                                                }},
                                                                {{
                                                                    getLocationByCode(segment.arrival.iataCode)[$i18n.locale
                                                                    + '_country']
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="index < arrival_flight.itineraries[1].segments.length - 1"
                                                    class="col-md-12">
                                                    <div class="clearfix layover">
                                                        <span>
                                                            {{ $t('Stop') }}
                                                            {{ getStopDuration($i18n.locale, segment.arrival.at,
                                                                arrival_flight.itineraries[1].segments[index +
                                                                    1].departure.at)
                                                            }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import $ from 'jquery';
import jsonDataEn from '@/assets/file/en-airports.json';
import jsonData from '@/assets/file/airports-v2.json';
import airlinesData from '@/assets/file/airlines.json';
import { convertDuration, formatTime, getStopDuration } from '@/utils/timeUtils';
import { formatDate } from '@/utils/dateUtils';
export default {
    name: 'BookingDetailsArea',
    data: () => ({
        departure_flight: null,
        arrival_flight: null,
        airlines: [],
        searchData: [],
        getOutboundImg: '',
        getInboundImg: '',
        tripType: '',
    }),
    methods: {
        getLocationByCode(code) {
            var info = jsonData.filter(item => {
                return item.code.includes(code);
            });
            return info[0];
        },
        getStopDuration(locale, date, date1) {
            return getStopDuration(locale, date, date1);
        },
        getFormattedDate(dateString) {
            const { day, month, year } = formatDate(dateString);
            return `${day} ${this.$t(month)} ${year}`;
        },
        getFormattedTime(timeString) {
            return formatTime(timeString);
        },
        convertDuration(duration) {
            return convertDuration(duration);
        },
        getCoordinates(data, code) {
            const location = data.find(item => item.code.includes(code));
            return { lat: location.lat, lng: location.lng };
        },
        buildMarkers(data, segments) {
            let markers = '', path = '';
            segments.forEach(segment => {
                const depCoords = this.getCoordinates(data, segment.departure.iataCode);
                const arrCoords = this.getCoordinates(data, segment.arrival.iataCode);
                markers += ` &markers=color:red|${depCoords.lat},${depCoords.lng}`;
                markers += ` &markers=color:red|${arrCoords.lat},${arrCoords.lng}`;
                path += `|${depCoords.lat},${depCoords.lng}|${arrCoords.lat},${arrCoords.lng}`;
            });
            return { markers, path };
        },
        generateMapUrl(centerLat, centerLng, size, markers, path, pathColor) {
            return `https://maps.google.com/maps/api/staticmap?
            center=${centerLat},${centerLng}
            &type=terrain
            &size=550x${size}
            &key=AIzaSyCU_-f44KpO2Mhupb-qWLQY-bp0_tQaUzs
            ${markers}
            &path=color:${pathColor}|weight:4|geodesic:true${path}
            &sensor=false
            &region=${this.$i18n.locale}`;
        },
    },
    mounted() {
        $('.pre-loader').show();
        var guest_data = JSON.parse(localStorage.getItem("guest_data"));
        if (!guest_data.guest.flight) {
            this.$router.go(-1);
        }
        this.airlines = airlinesData;
        this.tripType = guest_data.guest.flight.trip_type;
        if (this.tripType == 'oneway') {
            this.searchData = {
                "from": guest_data.guest.flight.departure_from,
                "to": guest_data.guest.flight.return_to,
                "date": guest_data.guest.flight.departure_date,
                "ret_date": '',
                "currency": 'SAR',
                "adults": 1,
                "children": 0,
                "infants": 0,
                "cabin": guest_data.guest.flight.cabin,
            };

            this.departure_flight = guest_data.guest.flight.all_flight_details.data.flightOffers[0];
            const departureSegments = this.departure_flight.itineraries[0].segments;
            const departureCoords = this.getCoordinates(jsonDataEn, this.searchData.to);
            const arrivalCoords = this.getCoordinates(jsonDataEn, this.searchData.from);

            const { markers, path } = this.buildMarkers(jsonDataEn, departureSegments);
            const centerLat = (parseFloat(departureCoords.lat) + parseFloat(arrivalCoords.lat)) / 2;
            const centerLng = (parseFloat(departureCoords.lng) + parseFloat(arrivalCoords.lng)) / 2;
            this.getOutboundImg = this.generateMapUrl(centerLat, centerLng, departureSegments.length === 1 ? 350 : departureSegments.length * 200, markers, path, '0xd1b26e');
        } else {
            this.searchData = {
                "from": guest_data.guest.flight.departure_from,
                "to": guest_data.guest.flight.return_to,
                "date": guest_data.guest.flight.departure_date,
                "ret_date": guest_data.guest.flight.return_date,
                "currency": 'SAR',
                "adults": 1,
                "children": 0,
                "infants": 0,
                "cabin": guest_data.guest.flight.cabin,
            };
            this.departure_flight = guest_data.guest.flight.all_flight_details.data.flightOffers[0];
            this.arrival_flight = guest_data.guest.flight.all_flight_details.data.flightOffers[0];

            const departureSegments = this.departure_flight.itineraries[0].segments;
            const returnSegments = this.departure_flight.itineraries[1].segments;

            // Outbound map
            const outboundDepartureCoords = this.getCoordinates(jsonDataEn, this.searchData.from);
            const outboundArrivalCoords = this.getCoordinates(jsonDataEn, this.searchData.to);
            const outboundData = this.buildMarkers(jsonDataEn, departureSegments);
            const outboundCenterLat = (parseFloat(outboundDepartureCoords.lat) + parseFloat(outboundArrivalCoords.lat)) / 2;
            const outboundCenterLng = (parseFloat(outboundDepartureCoords.lng) + parseFloat(outboundArrivalCoords.lng)) / 2;
            this.getOutboundImg = this.generateMapUrl(outboundCenterLat, outboundCenterLng, departureSegments.length === 1 ? 350 : departureSegments.length * 200, outboundData.markers, outboundData.path, '0xd1b26e');

            // Inbound map
            const inboundDepartureCoords = this.getCoordinates(jsonDataEn, this.searchData.to);
            const inboundArrivalCoords = this.getCoordinates(jsonDataEn, this.searchData.from);
            const inboundData = this.buildMarkers(jsonDataEn, returnSegments);
            const inboundCenterLat = (parseFloat(inboundDepartureCoords.lat) + parseFloat(inboundArrivalCoords.lat)) / 2;
            const inboundCenterLng = (parseFloat(inboundDepartureCoords.lng) + parseFloat(inboundArrivalCoords.lng)) / 2;
            this.getInboundImg = this.generateMapUrl(inboundCenterLat, inboundCenterLng, returnSegments.length === 1 ? 350 : returnSegments.length * 200, inboundData.markers, inboundData.path, '0xd1b26e');
        }
        $('.pre-loader').hide();
    }
}
</script>
<style lang="scss" scoped>
.color-label {
    color: #d1b26e!important;
    font-weight: 700!important;
    .note{
        color: rgb(192, 160, 52);
    }
}
.form-control{
        padding: 5px 22px;
        font-size: 14px;
        height: 40px;
        border-radius: 0.25rem;
}
label{
    font-size: 14px;
    margin-bottom: 8px;
    color: #d1b26e;
    font-weight: 600;
}
.form-group{
    margin-bottom: 1rem;
}
.section_padding {
    padding: 60px 0;
}
.page-loader-parent:has(.page-loader) {
    position: relative;
    min-height: 280px;
}

.mb20 {
    margin-bottom: 20px !important;
}

.pass-con {
    background-color: #0a0f57;
    color: #fff;
    padding: 15px;
    border-radius: 3px;
}

.row.align>.col-middle {
    float: none;
    display: inline-block;
    vertical-align: middle;
    clear: both;
    white-space: initial;
}

.rtl .pass-count {
    margin-right: 20px;
    margin-left: 0 !important;
}

.rtl .pass-count span {
    font-size: 14px;
}

.pass-con .btn,
.pass-con .btn:active,
.pass-con .btn:after,
.pass-con .btn:focus,
.pass-con .btn:hover {
    background-color: transparent;
    border: 1px solid #fff;
    color: #fff;
}

.mb30 {
    margin-bottom: 30px !important;
}

.row.align {
    padding: 0;
}

.sticky-parent {
    transition: 1s;
    bottom: 50px;
    position: sticky !important;
    position: -webkit-sticky !important;
    z-index: 100;
    top: 145px;
}

.pass-ticket-con {
    background: #fff;
    padding: 20px;
    border-radius: 3px;
    transition: .8s;
}


.oneway,
.oneway-2x,
.oneway-left,
.roundtrip,
.roundtrip-2x {
    background-repeat: no-repeat;
    display: inline-block;
    width: 50px;
    height: 26px;
    background-position: center;
    vertical-align: middle;
}

.flip {
    transform: scaleX(-1);
}

.fl-30-ico.calendar-pink-ico {
    background-position: -180px -300px;
}

.fl-30-ico {
    background-image: url('~@/assets/img/icons/30x30.png');
    width: 30px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
}

.fl-30-ico.passengers {
    background-position: 0 -90px;
}

.ticket-hole:after {
    right: -30px;
}

.ticket-hole:after,
.ticket-hole:before {
    content: '';
    width: 20px;
    height: 20px;
    background-color: #f0eee9;
    position: absolute;
    top: -12px;
    border-radius: 50%;
}

.ticket-hole:before {
    left: -30px;
}

.ticket-hole>hr {
    margin-top: 15px;
    margin-bottom: 15px;
    border-top: 1px dashed #a3a3a3;
}

.dash-line {
    border-top: 1px dashed #a3a3a3;
}

.ticket-hole {
    position: relative;
}

.mb0 {
    margin-bottom: 0px;
}

.passenger-info {
    padding-top: 145px;
}

.h4,
h4 {
    font-size: 18px;
}


.frm-js-lbl label {
    right: 0px;
    left: inherit;
}

.frm-js-lbl {
    margin: 0;
    padding: 0;
    border: 0;
    position: relative;
    height: 36px;
}

.pass-spec-container {
    background: #fff;
    max-height: 87px;
    cursor: pointer;
    position: relative;
    padding: 15px;
    border-radius: 3px;
}

.fl-pass-info .pass-image,
.pass-spec-container .pass-image {
    background-color: var(--main-color);
    color: #fff;
    font-size: 12px;
    border: 0;
    border-radius: 50%;
    margin: 0 0px;
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
    text-align: center;
    padding: 1;
    width: 40px;
    height: 40px;
    line-height: 35px;
    padding-top: 3px;
}

.mb20 {
    margin-bottom: 20px !important;
}

.pass-spec-container .pass-details .left {
    display: inline-block;
    vertical-align: middle;
}

.pass-spec-container .pass-details {
    display: inline-block;
    width: calc(100% - 35px);
    cursor: pointer;
    white-space: nowrap;
}

.btn-fa {
    width: 25px;
    display: inline-block;
    text-align: center;
    cursor: pointer;
}
.pass-spec-container .pass-details .right {
    text-align: right;
}

.pass-spec-container .pass-details .right {
    display: inline-block;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: calc(100% - 70px);
    direction: ltr;
    text-align: left;
}

.icheckbox_square,
.icheckbox_square-blue,
.icheckbox_square-green,
.icheckbox_square-grey,
.icheckbox_square-orange,
.icheckbox_square-pink,
.icheckbox_square-purple,
.icheckbox_square-red,
.icheckbox_square-yellow,
.iradio_square,
.iradio_square-blue,
.iradio_square-green,
.iradio_square-grey,
.iradio_square-orange,
.iradio_square-pink,
.iradio_square-purple,
.iradio_square-red,
.iradio_square-yellow {
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    padding: 0;
    width: 22px;
    height: 22px;
    border: none;
}

.no-margin {
    margin: 0;
}

.checkbox-container {
    display: inline-block;
    position: relative;
    padding-left: 25px;
    cursor: pointer;
}

.checkbox-container input[type="radio"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.checkmark {
    position: absolute;
    top: -12px;
    left: 0;
    height: 22px;
    width: 22px;
    border-radius: 50%;
    border: 1px solid #ccc;
}

.checkbox-container input[type="radio"]:checked~.checkmark {
    background: url('~@/assets/img/icons/green.png') no-repeat;
    background-position: -49px -1px;
}

.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

.checkbox-container input[type="radio"]:checked~.checkmark:after {
    display: block;
}

.checkbox-container .checkmark:after {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 22px;
    height: 22px;
    border-radius: 50%;
}

.fl-30-ico.info-ico {
    background-position: -120px -270px;
}

.price-text .total {
    font-size: 24px;
}

.price-text .currency {
    font-size: 18px;
}

.new-bold-light {
    font-weight: 600;
    font-style: normal;
    color: #d1b26e;
}

.fl-30-ico {
    background-image: url('~@/assets/img/icons/30x30.png');
    width: 30px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
}

.itinerary-content {
    background-color: var(--theme-search-form-bg);
    border-radius: 6px;
    padding-bottom: 5px;
}

#booked-inbound img,
#booked-outbound img,
#inbound-map img,
#outbound-map img {
    width: 100%;
}

.p10 {
    padding: 10px;
}

.fl-back,
.trip-out,
.trip-in,
.chev-arrow.right,
.chev-arrow.left,
.fl-trip .outbound,
.fl-trip .inbound {
    transform: scaleX(-1);
}

.trip-out,
.trip-out.white {
    background-position: 0 0;
}

.fl-trip {
    display: inline-block;
    vertical-align: middle;
}

.fl-trip {
    margin-right: inherit;
    margin-left: 15px;
}

.ml15 {
    margin-left: 15px !important;
}

.fl-pass-info .seat-img {
    width: 35px;
}
.mr15 {
    margin-right: 15px !important;
}

.fl-30-ico.fl-coupon {
    background-position: -210px 0;
}

.fl-30-ico {
    background-image: url('~@/assets/img/icons/30x30.png');
    width: 30px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
}

.fl-30-ico.fl-cards {
    background-position: -60px -210px;
}

.border-top-1 {
    border-top: 1px solid #bdbdbd;
}


.checkbox-container {
    display: inline-block;
    position: relative;
    padding-left: 25px;
    cursor: pointer;
}

.checkbox-container input[type="radio"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.checkmark {
    position: absolute;
    top: -10px;
    left: 0;
    height: 22px;
    width: 22px;
    border-radius: 50%;
    border: 1px solid #ccc;
}

.checkbox-container input[type="radio"]:checked~.checkmark {
    background: url('~@/assets/img/icons/green.png') no-repeat;
    background-position: -49px -1px;
}

.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

.checkbox-container input[type="radio"]:checked~.checkmark:after {
    display: block;
}

.checkbox-container .checkmark:after {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 22px;
    height: 22px;
    border-radius: 50%;
}

.search-bar-wrapper {
    background-color: #fff;
    background-color: #0a0f57;
    width: 100%;
    margin-bottom: 20px;
    transition: .3s;
    color: #fff;
    z-index: 998;
    width: 100%;
    position: fixed;
    top: 60px;
    max-height: 147px;
}

.fl-back {
    background-image: url('~@/assets/img/icons/back-left.png');
    height: 24px;
    width: 27px;
}

.rtl .fl-back {
    transform: scaleX(-1);
}

.lh-50 {
    line-height: 50px;
}

.pl0 {
    padding-left: 0 !important;
}

.pr0 {
    padding-right: 0 !important;
}

.btn-search-outline {
    background: 0 0;
    border: 1px solid #e6f0ff;
    color: #e6f0ff;
    outline: 0;
    box-shadow: none;
}

.p10 {
    padding: 10px;
}

.bold {
    font-weight: 500;
    font-style: normal;
}

.padding-10-15 {
    padding: 10px 15px;
}

.bk-nav-ul,
.dh-nav-ul {
    list-style: none;
    height: 100%;
    padding: 0;
    min-height: 55px;
    padding-top: 10px;
}

.pull-left {
    float: right !important;
}

.bk-nav-ul>li,
.dh-nav-ul>li {
    display: inline-block;
    height: 100%;
    white-space: nowrap;
}

.corporate-logo {
    display: inline-block;
    background-position: center;
    background-repeat: no-repeat;
    height: 55px;
    object-fit: contain;
    width: 100px;
    margin-right: -20px;
}

.bk-nav-ul>li>a,
.bk-nav-ul>li>div,
.dh-nav-ul>li>a,
.dh-nav-ul>li>div {
    color: rgba(255, 255, 255, .5);
    padding: 10px;
    position: relative;
    display: inline-block;
    vertical-align: middle;
}

.bk-nav-ul>li>a.active {
    color: #fff;
}

.height-100p {
    height: 100%;
}

.booking-nav {
    background-color: #fff;
    background-color: #0a0f57;
    width: 100%;
    margin-bottom: 20px;
    transition: .3s;
    color: #fff;
    z-index: 998;
    width: 100%;
    position: fixed;
    top: 60px;
    height: 65px;
}

.fl-back {
    background-position: center;
    display: inline-block;
    background-repeat: no-repeat;
    vertical-align: middle;
    cursor: pointer;
}
.division {
    border-bottom: 1px solid #f1f1f1;
    padding: 0;
}

.pull-spinner {
    display: block;
    height: 25px;
    width: 25px;
    margin: 0 auto;
    position: relative;
    left: -4px;
    animation: rotation .6s infinite linear;
    border-left: 4px solid rgba(202, 202, 202, .15);
    border-right: 4px solid rgba(202, 202, 202, .15);
    border-bottom: 4px solid rgba(202, 202, 202, .15);
    border-top: 4px solid rgba(202, 202, 202, .9);
    border-radius: 100%;
}

.fl-ico.negative {
    background-position: -115px -45px;
}

.purposeOfTravel {
    color: #939393;
    margin-top: 24px;
}




.footer-card {
    position: relative;
}


.ml5 {
    margin-left: 5px !important;
}

.mr5 {
    margin-right: 5px !important;
}

 #inbound-map,
    .flight-map {
        width: 100%;
        position: relative;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #a5a5a5;
    }
@media only screen and (max-width: 600px) {
    .sticky-parent {
        position: relative !important;
        top: 20px !important;
    }

    #inbound-map,
    .flight-map {
        min-height: 100% !important;
    }
    .w-30{
        width: 100% !important;
    }
}
</style>
<style lang="scss">
.fl-itinerary>div:last-child {
    border-left: 1px dashed #bdbdbd;
    border-right: 0px;
}

.fl-itinerary>div:first-child {
    border-right: 1px dashed #bdbdbd;
    border-left: 0px;
}
.rtl .fl-itinerary>div:last-child {
    border-right: 1px dashed #bdbdbd;
    border-left: 0px;
}

.rtl .fl-itinerary>div:first-child {
    border-left: 1px dashed #bdbdbd;
    border-right: 0px;
}

.text-center {
    text-align: center !important;
}


.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: inherit;
    font-weight: 600;
    line-height: 1.1;
    color: inherit;
}

.section_padding {
    font-size: 14px;
    letter-spacing: .01em;
}
.fl-img-con {
    display: inline-block;
    height: 50px;
    width: 50px;
    line-height: 60px;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    background-color: #fff;
    text-align: -webkit-center;
}

.layover {
    text-align: center;
    padding: 10px 0;
    border-left-color: transparent;
    border-right-color: transparent;
    background-color: rgb(209 178 110);
    margin: 0 15px;
    color: #ffffff;
    border-radius: 4px;
}

.mb15 {
    margin-bottom: 15px !important;
}

.p20 {
    padding: 20px;
}

.itinerary-content {
    background-color: var(--theme-search-form-bg);
    border-radius: 6px;
    padding: 20px 10px;
    box-shadow: -4px -5px 14px rgba(0, 0, 0, 0.08), 5px 8px 16px rgba(0, 0, 0, 0.08);
}

.mb20 {
    margin-bottom: 20px !important;
}

.mt15 {
    margin-top: 15px !important;
}

.mb15 {
    margin-bottom: 15px !important;
}

.fl-ico.negative {
    background-position: -115px -45px;
}

.new-bold-light {
    font-weight: 600;
    font-style: normal;
    color: #d1b26e;
    font-size: 18px;
}

.bold {
    font-weight: 600;
    font-style: normal;
}

.mt10 {
    margin-top: 10px !important;
}

.fl-trip {
    display: inline-block;
    vertical-align: middle;
    margin-right: inherit;
    margin-left: 15px;
}

.mb20 {
    margin-bottom: 20px !important;
}

.mt15 {
    margin-top: 15px !important;
}

.no-margin {
    margin: 0;
}

.form-group:has(select) {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  .form-group select.form-control {
    width: 100%;
    padding: 5px 12px;
    border: 1px solid #ced4da;
    border-radius: 4px !important;
    font-size: 16px;
    color: var(--input-color);
    background-color: var(--flight-search-bg);
    appearance: none;
    outline: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
  }

  .form-group select.form-control:focus {
    border-color: var(--main-color);
  }
  .form-group:has(select):focus-within::after {
    transform: translateY(-50%) rotate(180deg);
  }
  .form-group select.form-control option {
    background-color: #fff;
    color: #495057;
    font-size: 16px;
    padding: 10px;
  }
  .form-group  select.form-control option:checked {
    background-color:  var(--main-color);
    color: #fff;
  }
</style>